import React, { useState, useEffect } from 'react';
import Fade from '@material-ui/core/Fade';
import ForgottenPassword from './ForgottenPassword';
import FPVerification from './FPVerification';
import FPConfirmation from './FPConfirmation';


const ForgottenPasswordContaner = ({onBack, onForward} ) => {

    const [step, setStep] = useState(1);
    const [showFade, setShowFade] = useState(true);
    const [verificationData, setVerificationData] = useState({});
     //for testing only 
    // const [verificationData, setVerificationData] = useState({countryCode: '359', phoneNo: '888792833', email: 'rp@yahoo.com' });

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [step]);

    const goBack = (toStep) => {
        setShowFade(false);

        setTimeout(() => {
          setStep(toStep);
          setShowFade(true);
        }, 0);
    }

    const goForward = (toStep) => {
        setShowFade(false);

        setTimeout(() => {
          setStep(toStep);
          setShowFade(true);
        }, 0);
    }

    const goToFPVerification = (data) => {
        setVerificationData({...data});
        goForward(2)
    }

    const goToProfile = () => {
        onForward(1);
    }

    const renderStepScreen = () => {

        switch (step) {
            case 1:
              return <ForgottenPassword onBack={onBack} onForward={goToFPVerification} />;
            case 2:
              return <FPVerification onBack={goBack} onForward={goForward} verificationData={verificationData} />;
            case 3:
              return <FPConfirmation onBack={goBack} onForward={goToProfile} />;

            default:
              return <div></div>;
        }
    }

    return (
        <div style={{position: 'realtive'}}>
            <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
              {renderStepScreen()}
            </Fade>
        </div>
    )
}

export default ForgottenPasswordContaner;